import './css/rusroman.scss'
import renderCarousels from './carousel/renderCarousels.js'
import renderIcons from './renderIcons.js'
import printSchedule from './printSchedule.js'
import headerMenu from './headerMenu.js'
import setSearchValue from './setSearchValue.js'
import tabs from './tabs.js'
// import videoPlayer from "./player/videoPlayer";
import CookieWidget from './cookieWidget.js'

document.addEventListener('DOMContentLoaded', () => {
  renderIcons()
  renderCarousels()
  printSchedule()
  headerMenu()
  setSearchValue()
  tabs()
 // videoPlayer()
   const cookieWidget = new CookieWidget({
    cookieName: 'RuCookie',
    cookieExpiryHrs: 48, // Cookie на 48 часов
    cookieTheme: 'is-dark', // сейчас 2 темы: дефолтная и тёмная
    cookieHtml: null, // если надо заменить html виджета
    cookieScroll: 96 // если задан, то виджет инициализируется по скроллу, типа 100px
  });
})
window.addEventListener('load', () => {
	document.querySelector('.load').classList.remove('load')
})
